import React, { useMemo } from "react";
import PropTypes from "prop-types";
import CircularProgressbar from "react-circular-progressbar";

const ITHealthScore = ({ contract }) => {
  const proactiveMonitoring = useMemo(() => {
    const {
      antivirus,
      proactive_monitoring_coverage,
      proactive_monitoring_protection
    } = contract;

    let value = 0;
    let amount = 0;

    if (typeof antivirus === "number" && antivirus > 0) {
      value += antivirus;
      amount += 1;
    }

    if (
      typeof proactive_monitoring_coverage === "number" &&
      proactive_monitoring_coverage > 0
    ) {
      value += proactive_monitoring_coverage;
      amount += 1;
    }

    if (
      typeof proactive_monitoring_protection === "number" &&
      proactive_monitoring_protection > 0
    ) {
      value += proactive_monitoring_protection;
      amount += 1;
    }

    return value / amount;
  }, [contract]);

  const patchManagment = useMemo(() => {
    const { patch_management_coverage, patch_management_protection } = contract;

    let value = 0;
    let amount = 0;

    if (
      typeof patch_management_coverage === "number" &&
      patch_management_coverage > 0
    ) {
      value += patch_management_coverage;
      amount += 1;
    }

    if (
      typeof patch_management_protection === "number" &&
      patch_management_protection > 0
    ) {
      value += patch_management_protection;
      amount += 1;
    }

    return value / amount;
  }, [contract]);

  const healthScore = useMemo(() => {
    const { server_availability, failed_login_attempts } = contract;

    let value = 0;
    let amount = 0;

    if (typeof server_availability === "number" && server_availability > 0) {
      value += server_availability;
      amount += 1;
    }

    if (typeof failed_login_attempts === "number") {
      value += 100 - failed_login_attempts;
      amount += 1;
    }

    if (
      typeof proactiveMonitoring === "number" &&
      !Number.isNaN(proactiveMonitoring)
    ) {
      value += proactiveMonitoring;
      amount += 1;
    }

    if (typeof patchManagment === "number" && !Number.isNaN(patchManagment)) {
      value += patchManagment;
      amount += 1;
    }

    return value / amount;
  }, [contract, proactiveMonitoring, patchManagment]);

  return (
    <div className="content-wrapper it-hs-container">
      <h1>IT Health Score</h1>
      <div className="it-hs-wrapper">
        <CircularProgressbar
          percentage={
            typeof healthScore === "number" && !Number.isNaN(healthScore)
              ? healthScore
              : 0
          }
          strokeWidth={10}
          text={
            typeof healthScore === "number" && !Number.isNaN(healthScore)
              ? `${healthScore.toFixed(1).replace(/[.,]0$/, "")}%`
              : "N/A"
          }
        />
        <div className="titles">
          <span className="upper blue mb-15">Proactive Monitoring</span>
          <span>Antivirus</span>
          <span>Coverage</span>
          <span className="mb-15">Protection</span>
          <span className="upper blue mb-15">Server Availability</span>
          <span className="upper blue">Patch Management</span>
          <span>Coverage</span>
          <span className="mb-15">Protection</span>
          <span className="upper blue">Failed Login Attempts</span>
        </div>
        <div className="values">
          <span className="mb-15">
            {typeof proactiveMonitoring === "number" &&
            !Number.isNaN(proactiveMonitoring)
              ? `${proactiveMonitoring.toFixed(1).replace(/[.,]0$/, "")}%`
              : "N/A"}
          </span>
          <span>{contract.antivirus ? `${contract.antivirus}%` : "N/A"}</span>
          <span>
            {contract.proactive_monitoring_coverage
              ? `${contract.proactive_monitoring_coverage}%`
              : "N/A"}
          </span>
          <span className="mb-15">
            {contract.proactive_monitoring_protection
              ? `${contract.proactive_monitoring_protection}%`
              : "N/A"}
          </span>
          <span className="mb-15">
            {contract.server_availability
              ? `${contract.server_availability}%`
              : "N/A"}
          </span>
          <span>
            {typeof patchManagment === "number" && !Number.isNaN(patchManagment)
              ? `${patchManagment.toFixed(1).replace(/[.,]0$/, "")}%`
              : "N/A"}
          </span>
          <span>
            {contract.patch_management_coverage
              ? `${contract.patch_management_coverage}%`
              : "N/A"}
          </span>
          <span className="mb-15">
            {contract.patch_management_protection
              ? `${contract.patch_management_protection}%`
              : "N/A"}
          </span>
          <span>
            {contract.failed_login_attempts >= 0
              ? `${contract.failed_login_attempts}%`
              : "N/A"}
          </span>
        </div>
      </div>
    </div>
  );
};

ITHealthScore.propTypes = {
  contract: PropTypes.object
};

ITHealthScore.defaultProps = {
  contract: {}
};

export default ITHealthScore;
